/// <reference path="../html5controls/Controls/inforTabset/js/inforTabset.js"/>
function initializeModuleTabs() {
  if (instance.easeOfUse.useInforDesign === false) {
    $("#inforTabContainer").inforTabset({
      closable: false,
      sortable: false,
      editable: false,
      animate: false
    });
    $("#inforTabContainer").tabs({
      beforeActivate: function(event, ui) {
        var vid = this.getAttribute("vid");
        SelectTab(ui.newPanel.attr('id'), ui.newPanel.attr('id'), true);
      },
      refresh: function(event, ui) {
        ui.newTab.setAttribute("vid", ui.newPanel.id);
      }
    });
  }
}
function updateSessionIcon(vid, targetViewId) {
  var hideMenu = menuHidden();
  if (!hideMenu) {
    $("#inforModuleHeaderRight")
      .children()
      .hide();
    $("#settings" + vid).show();
  }
}
function updateModuleHeader(title, recordId, targetViewId) {
  instance.document.title = title;
  if (recordId != undefined) {
    $(".inforModuleRecordIdText", document).html(recordId);
    instance.document.title += " | " + recordId;
  }
  instance.document.title += " | IPS";
  var $headerModule = $("#inforModuleHeaderRight", document);
  $headerModule.data("vid", targetViewId);
  var hideMenu = menuHidden();
  if (!hideMenu) {
    $("#inforModuleHeaderRight", document)
      .children()
      .hide();
    // Hide form code popup
    var $formCodePopup = $("#__formcodeautocomplete", document);
    if ($formCodePopup.length > 0) {
      $formCodePopup.hide();
    }
    $("#settings" + targetViewId, document).show();
    //the focus cannot be set until the parent is visible
    $("#__formcodeinput__").focus();
  }
  if (instance.isModalDiv) {
    instance.modalDivContext.setTitle(title);
  }
}
function updateSessionItem(sessionId, targetViewId, sessionText) {
  if (instance.easeOfUse.useInforDesign === false) {
    const tabContainer = $("#inforTabContainer");

    // Have to select the items using `aria-controls` attribute
    const targetTab = tabContainer.find(`li[aria-controls="${sessionId}"]`);
    
    if (targetTab.length > 0) {
      targetTab.find("a").text(sessionText);
    }

    var moreButton = document.querySelector('.inforTabButton[aria-haspopup="true"]');

    if (moreButton && moreButton.querySelector('button.inforMoreButton') && moreButton.style.display === 'block') {
        const targetTabIndex = targetTab.index();
        const popupMenu = instance.frames['menuAndView'].document.querySelector("ul.popupmenu");
      
        if (popupMenu) {
        const targetLi = popupMenu.querySelector(`li[class="${targetTabIndex}"]`);
        if (targetLi) {
          const targetAnchor = targetLi.querySelector('a');
          if (targetAnchor) {
            targetAnchor.textContent = sessionText;
          }
        }
      }
    }
  } else {
    $(`#${sessionId}-module-tab`).html(sessionText);
  }
}
//Add an Item to the session menu
function addSessionItem(sessionId, sessionText, targetViewId) {
  if (instance.easeOfUse.useInforDesign === false) {
    if (!sessionText) {
      sessionText =
        '<div id="inforLoadingOverlay" class="inforBusyIndicator appNav small"></div>';
    }
    // if (sessionText == null) sessionText = "";
    $("#inforTabContainer").inforTabset(
      "add",
      "#" + sessionId,
      sessionText,
      false
    );
  
  //   $("#inforTabContainer").find(`a[href="#${sessionId}"]`).on("click", function(event) {
  //   event.preventDefault();
  //   $("#hansenView").contents().find("iframe").hide();
  
  //   $("#hansenView").contents().find("iframe").each(function() {
  //     var iframeSrc = $(this).attr("src");
  
  //     // This part checks the sessionId in the iframe's src attribute to make sure that we're dealing in the proper iframe content
  //     if (iframeSrc.includes(sessionId)) {
  //       $(this).show();
  //     }
  //   });
  // });
  } 
  else {
    if (!sessionText) {
      sessionText = "";
    }
    $(`<ids-tab color-variant="module" id="${sessionId}-module-tab"  value="${sessionId}">${sessionText}</ids-tab>`).appendTo("#inforTabContainer");
  }

}
//Remove an Item from the session menu
function selectSessionItem(sessionId, targetViewId) {
  if (instance.easeOfUse.useInforDesign === false)
    $("#inforTabContainer").tabs("option","active", sessionId);
  else
    $("#inforTabContainer").value = sessionId;
}
//Remove an Item from the session menu
function removeSessionItem(sessionId, targetViewId) {
  var a = $("#inforTabContainer").find("a[vid=" + sessionId + "]");
  //$("#inforTabContainer").tabs("remove", "#" + sessionId);
  $("#inforTabContainer").inforTabset("remove", '"#' + sessionId + '"');
  //$(a).off("click");
}
function AddModuleMenuOptionsInHeader(targetViewId) {
  if (!_jqueryScriptAdded) {
    _jqueryScriptAdded = true;
    var fileref = document.createElement("script");
    fileref.setAttribute("type", "text/javascript");
    fileref.setAttribute("src", "Client/inforControlsCombined.js");
    document.getElementsByTagName("head")[0].appendChild(fileref);
  }
  var buttonId = "settings" + targetViewId;
  var $headerModule = $("#inforModuleHeaderRight", document);
  var $button = findModuleOptionButton(buttonId, $headerModule);
  var currentVid = $headerModule.data("vid");
  if (currentVid == undefined || currentVid == targetViewId) {
    $headerModule.data("vid", currentVid);
    var hidden = $button.css("display") == "none";
    if (hidden) {
      $button.show();
    }
  }
  $button.off("click");
  $button.on("click", function(e) {
    var view = GetView(targetViewId);
    var button = $button.get(0);
    view.openPopupMenu({
      items: view.moduleSettingsCommands,
      parentControl: button,
      containingDocument: document,
      $jquery: $
    });
    return false;
  });
}
function RemoveModuleMenuOptionsInHeader(targetViewId) {
  var buttonId = "settings" + targetViewId;
  var $headerModule = $("#inforModuleHeaderRight", document);
  $headerModule.find("#" + buttonId).off();
}
function findModuleOptionButton(buttonId, $headerModule) {
  var $button = $headerModule.find("#" + buttonId);
  if ($button.length == 0) {
    var hideMenu = menuHidden();
    var display = "none";
    if (hideMenu) {
      display = "block";
    }
    $button = $(
      '<button tabIndex="0" style="display:' +
        display +
        ';" class="inforModuleSettingsButton" id="' +
        buttonId +
        '" title="Menu"><i></i></button>'
    );
    $button.appendTo($headerModule);
  }
  return $button;
}
